import React, { useState, useEffect } from "react";

import InputField from "../../../../common/InputField";
import * as Yup from "yup";

import { Form, Formik } from "formik";
import { Typography, Box, Container } from "@mui/material";
import { PrimaryButton, SecondaryButton } from "../../../../common/Buttons";
import {
  getGuardianOridinance,
  postGuardianOridinance,
} from "../../../../services/documentServices";
import { toast } from "react-hot-toast";
import { setStepStatus } from "../../../../utils/Utilities";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";

const validate = (t) => {
  return Yup.object({
    name: Yup.string().max(50, t("max-50-characters")),
    address: Yup.string(),
    email: Yup.string().email(t("Must-be-ValidEmail")),
    dateOfBirth: Yup.string(),
    phone: Yup.number(t("must-be-number"))
      .min(0, t("must-be-positive"))
      .test(
        "len",
        t("less-than-15"),
        (val) => !val || (val && val.toString().length <= 15)
      ),
  });
};

const SecondaryGuardian = (props) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [initialValues, setInitialValues] = useState({
    name: "",
    address: "",
    email: "",
    dateOfBirth: "",

    phone: "",
  });

  async function fetchData() {
    props.setButtonDisabled(true);
    setIsLoading(true);
    const result = await getGuardianOridinance(id);
    try {
      if (result?.success) {
        setData(result?.payLoad);
        if (result.payLoad.secondaryGuardian !== null) {
          const { dateOfBirth, ...rest } = result.payLoad.secondaryGuardian;
          setInitialValues({ ...rest, dateOfBirth: dateOfBirth?.slice(0, 10) });
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      props.setButtonDisabled(false);
      setIsLoading(false);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);
  const handleSubmit = async (values) => {
    props.setButtonDisabled(true);
    const {
      stepStatus,
      guardianOrdinanceId,
      secondaryGuardianId,
      dateOfBirth,
      ...rest
    } = values;
    const payload = {
      ...data,
      secondaryGuardian: {
        ...rest,
        guardianOrdinanceId,
        secondaryGuardianId,
        dateOfBirth: dateOfBirth === "" ? null : dateOfBirth,
        stepStatus: setStepStatus(dateOfBirth, { ...rest }),
      },
    };
    const result = await postGuardianOridinance(payload, id);
    if (result?.success) {
      props.next();
    }
    props.setButtonDisabled(false);
  };
  return (
    <>
      <Container
        className="summary-table documents-card-height"
        style={{ display: "flex", justifyContent: "center" }}
      >
        {isLoading ? (
          <Box component="div" className="loader-container">
            <Circles color="#dfc8db" height={80} width={80} />
          </Box>
        ) : (
          <Box sx={{ marginTop: "40px" }} width="60%">
            <Typography variant="p" paragraph align="left" color="color.black">
              IF THE PREVIOUS PERSON CANNOT BE APPOINTED AS GUARDIAN, THE
              FOLLOWING PERSON SHALL BE APPOINTED:{" "}
            </Typography>
            <Formik
              initialValues={initialValues}
              enableReinitialize
              validationSchema={() => validate(t)}
              onSubmit={(values) => {
                handleSubmit(values);
              }}
            >
              {(formik) => (
                <Form id="form_submit" onSubmit={formik.handleSubmit}>
                  <InputField
                    fullWidth
                    variant="standard"
                    placeholder="John"
                    label={t("input-5")}
                    name="name"
                    type="text"
                  />

                  <InputField
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    variant="standard"
                    label={t("input-2")}
                    name="dateOfBirth"
                    type="date"
                  />

                  <InputField
                    variant="standard"
                    placeholder="address "
                    label={t("input-12")}
                    name="address"
                    type="text"
                  />

                  <InputField
                    fullWidth
                    variant="standard"
                    placeholder="demo@gmail.com"
                    label={t("input-3")}
                    name="email"
                    type="email"
                  />
                  <InputField
                    fullWidth
                    variant="standard"
                    placeholder="2842394789"
                    label={t("input-4")}
                    name="phone"
                    type="number"
                    InputLabelProps={{ shrink: true }}
                  />
                </Form>
              )}
            </Formik>
          </Box>
        )}
      </Container>
    </>
  );
};

export default SecondaryGuardian;
